import {IDataModelTypeConfig} from "frontend/dataModels/types/IDataModelTypeConfig";

export const TSLDataModelTypeConfig: IDataModelTypeConfig = {
  fields: [
    'id',
    'name'
  ],
  subscriptions: {
    items: 'TslsChannel',
  },
  defaultColumns: [
  
  ],
  columnConfig: {

  }
}